import { Input, LoadingButton, Select, TextArea } from 'components/form'
import React, { useState } from 'react'
import { contactUsApi } from 'services/profile';
import { optionsValue, subjectValue } from 'utils/dropdownValue/selectBoxValue';
import { allowAlphaNumericWithLeadingAlpha, isValidEmail } from 'utils/inputValueValidation';
import { failMessage, successMessage } from 'utils/toastMessage';

const Query = ({ QuestionList = [] }) => {
    const [formData, setFormData] = useState({ subject: '', message: '', question: '' });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    // console.log('QuestionList', QuestionList)

    //-----------validation----------------
    const validation = () => {
        let status = true
        let errorMessage = {}
        if (!formData?.subject) {
            errorMessage['subject'] = 'Please select your subject'
            status = false
        }
        // else if (!isValidEmail(formData?.subject)) {
        //     errorMessage["subject"] = "Please enter valid email";
        //     errorMessage["emailInvalid"] = true
        //     status = false;
        // }
        if (formData?.subject === 'other' && !formData?.question) {
            errorMessage["question"] = "Please enter your question";
            status = false;
        }
        if (!formData?.message) {
            errorMessage['message'] = 'Please enter your message'
            status = false
        }
        setErrors(errorMessage)
        return status
    }
    //-----------handle-onChange-----------
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'subject') {
            setFormData((prevData) => ({ ...prevData, [name]: value, question: '' }));
        } else {
            setFormData({ ...formData, [name]: allowAlphaNumericWithLeadingAlpha(value) });
        }
    };

    //---------contact-us-----------------
    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (validation()) {
            try {
                setLoading(true);
                const payload = {
                    subject: formData?.subject === 'other' ? formData?.question : formData?.subject,
                    message: formData?.message
                };
                const res = await contactUsApi(payload);
                if (res?.status === 200) {
                    successMessage(res)
                    setFormData({ subject: '', message: '', question: '' });
                } else {
                    failMessage(res)
                }
            } catch (e) {
                console.log("Error:-", e.message);
            } finally {
                setLoading(false);
            }
        }
    };
    return (
        <form >
            <h4>Any questions or remarks? just write  us a message</h4>
            <div className="form_field">
                <Select
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    error={errors?.subject}
                >
                    <option value="" disabled>Please select your subject</option>
                    {QuestionList && QuestionList.length > 0 ? (
                        QuestionList?.map(({ _id, name }) =>
                            optionsValue(name.toLowerCase() === "other" ? "other" : name, name, _id)
                        )
                    ) : (
                        <option disabled>No subjects available</option>
                    )}
                </Select>
            </div>
            {formData?.subject === 'other' &&
                <div className="form_field">
                    <Input
                        type="text"
                        name="question"
                        placeholder="Enter your question"
                        value={formData.question}
                        onChange={handleChange}
                        error={errors?.question}
                        maxLength={100}
                    />
                </div>}
            <div className="form_field">
                <TextArea
                    name="message"
                    placeholder="Write here..."
                    value={formData.message}
                    onChange={handleChange}
                    error={errors?.message}
                />
            </div>

            <div className="button_wrap button_right">
                <LoadingButton loading={loading} onClick={handleSubmit}>Submit</LoadingButton>
            </div>
        </form>
    )
}

export default Query